import HomeView from "../../components/HomeView"

export default HomeView



// WEBPACK FOOTER //
// ./src/pages/home/index.js